import { useEffect, useRef, useState } from "react";

function parseEurInput(value: string): number | null {
  const trimmed = value.trim().replace(",", ".");
  if (trimmed === "") return null;
  const num = Number.parseFloat(trimmed);
  if (Number.isNaN(num)) return null;
  return Math.round(num * 100);
}

function centsToDisplayString(cents: number | null): string {
  if (cents === null) return "";
  return (cents / 100).toLocaleString("de-DE", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
    useGrouping: false,
  });
}

interface MoneyInputProps {
  valueCents: number | null;
  onChange: (cents: number | null) => void;
  placeholder: string;
  className: string;
}

export function MoneyInput({ valueCents, onChange, placeholder, className }: MoneyInputProps) {
  const [raw, setRaw] = useState(() => centsToDisplayString(valueCents));
  const lastCommittedRef = useRef<number | null>(valueCents);

  useEffect(() => {
    if (valueCents !== lastCommittedRef.current) {
      setRaw(centsToDisplayString(valueCents));
      lastCommittedRef.current = valueCents;
    }
  }, [valueCents]);

  return (
    <input
      type="text"
      inputMode="decimal"
      value={raw}
      placeholder={placeholder}
      className={className}
      onChange={(e) => {
        const v = e.target.value;
        setRaw(v);
        const parsed = parseEurInput(v);
        if (v.trim() === "" || parsed !== null) {
          lastCommittedRef.current = parsed;
          onChange(parsed);
        }
      }}
      onBlur={() => {
        const parsed = parseEurInput(raw);
        setRaw(centsToDisplayString(parsed));
        lastCommittedRef.current = parsed;
        onChange(parsed);
      }}
    />
  );
}
